import React from "react";
import { getFlagCdnUrl } from "../../utils/countryFlagUtils";

/**
 * Renders a single country flag from FlagCDN.
 *
 * @param {Object} props
 * @param {string} props.countryCode - ISO or VAT country code (e.g. IT, EL, GB).
 * @param {string} [props.size='w20'] - FlagCDN size token (w20, w40, h20, ...).
 * @param {string} [props.format='webp'] - Image format (png, webp, svg).
 * @param {string} [props.alt='Flag'] - Base alt text; country code is appended.
 * @param {Object} [props.imgProps] - Extra props for the img element.
 */
const CountryFlag = ({
  countryCode,
  size = "w20",
  format = "webp",
  alt = "Flag",
  imgProps = {},
}) => {
  if (!countryCode) {
    return null;
  }

  const flagUrl = getFlagCdnUrl(countryCode, size, format);
  if (!flagUrl) {
    return null;
  }

  return (
    <img
      src={flagUrl}
      alt={`${alt} ${String(countryCode).toUpperCase()}`}
      loading="lazy"
      decoding="async"
      {...imgProps}
    />
  );
};

export default React.memo(CountryFlag);
